import React from 'react';

// Brand two-way band: allowed [map,mrp] green; violators marked outside.
export default function AllowedBand({ map, mrp, worstBelow, worstAbove }) {
  if (map == null || mrp == null) return null;
  const lo = Math.min(map, worstBelow == null ? map : worstBelow);
  const hi = Math.max(mrp, worstAbove == null ? mrp : worstAbove);
  const span = (hi - lo) || 1;
  const pct = (v) => `${((v - lo) / span) * 100}%`;
  return (
    <div className="pux-allowed" title={`MAP ${map} - MRP ${mrp}`}>
      <div className="pux-allowed-ok" style={{ left: pct(map), right: `${100 - parseFloat(pct(mrp))}%` }} />
      {worstBelow != null && <div className="pux-allowed-mark" style={{ left: pct(worstBelow) }} />}
      {worstAbove != null && <div className="pux-allowed-mark" style={{ left: pct(worstAbove) }} />}
    </div>
  );
}
